import { getCustomFieldViewSections } from "@/components/custom-field/custom-field-view-sections.ts";
import { CustomFieldViewSections } from "@/components/custom-field/CustomFieldViewSections.tsx";
import useCustomFieldsWithEmployees from "@/hooks/use-custom-fields-with-employees.hook.ts";
import useJobCustomFieldsHook from "@/hooks/use-job-custom-fields.hook.tsx";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { getJobFormSections } from "@/pages/recruit/jobs/edit/job-edit-fields.ts";
import { useEntityFormConfig } from "@/queries/use-custom-fields.query.ts";
import { ApiCFEntityTypes, ApiFieldTypes } from "@/types/custom-field.types.ts";
import { ApiJob } from "@/types/recruit/job.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const JobViewFields = ({ job }: { job: ApiJob }) => {
  const config = useEntityFormConfig(ApiCFEntityTypes.job);
  const { isFeatureEnabled } = usePermissions();
  const { renderJobFieldListItem } = useJobCustomFieldsHook();
  const showCurrency = config.hasField(ApiFieldTypes.job_currency);
  const jobWithEmployees: ApiJob = {
    ...job,
    custom_fields: useCustomFieldsWithEmployees(job.custom_fields ?? []),
  };

  const sections = getCustomFieldViewSections(
    getJobFormSections(config.sections, isFeatureEnabled(ApiFeatureType.approvals)),
    (field) => renderJobFieldListItem(field, jobWithEmployees, showCurrency)
  );

  return <CustomFieldViewSections sections={sections} isPending={config.isPending} paddingTop />;
};
